import Button from 'components/button'
import { Dialog, SizableText, XStack } from 'tamagui'
import Modal from 'components/modal'
import { Blocker } from 'react-router'

interface UnsavedModalProps {
    blocker: Blocker
    save: (onSuccess: () => void, onFail: () => void) => Promise<void>
}

export default ({ blocker, save }: UnsavedModalProps) => {
    return (
        <Modal
            open={blocker.state === 'blocked'}
            onOpenChange={(open) => {
                if (!open) blocker.reset?.()
            }}
        >
            <Dialog.Title fontWeight="700" letterSpacing={-0.3}>Unsaved Changes</Dialog.Title>
            <SizableText>
                You have unsaved changes. Do you want to save the changes before you leave?
            </SizableText>
            <XStack gap="$4" flexDirection="row-reverse">
                <Button
                    theme="red"
                    variant="outlined"
                    onPress={() => blocker.proceed!()}
                    marginRight="auto"
                >
                    Don't Save
                </Button>
                <Button
                    variant="outlined"
                    onPress={async () => blocker.reset!()}
                >
                    Cancel
                </Button>
                <Button
                    theme="primary"
                    onPress={async () => {
                        await save(
                            () => {
                                blocker.proceed!()
                            },
                            () => {
                                blocker.reset!()
                            },
                        )
                    }}
                >
                    Save
                </Button>
            </XStack>
        </Modal>
    )
}
